/**
 * Isolated so tests can mock it: `import.meta.url` is what lets webpack 5 bundle
 * the worker as its own chunk, and it is exactly what Jest cannot run.
 */
export default function createLayoutWorker() {
  return new Worker(new URL('./graphLayout.worker.js', import.meta.url));
}
